import React from "react";
import Typography from '@mui/material/Typography'
import { useRouteError } from "react-router-dom";


function Error() {
    const error = useRouteError();
    // console.error("Navigation Error:", error.message);

    let errorMessage = "Navigation Error:" + error.message; 
    if (error.statusText) {
        errorMessage = error.statusText;
    } else if (error.data && error.data.message) {
        errorMessage = error.data.message;
    }

    return(
        <div className="padding-top-64" color="red">
            <Typography variant="body1" gutterBottom sx={{ color: 'red'}}>
                Error {errorMessage}
                {error.status}
            </Typography>
        </div>
    );
}

export default Error;
